import { objectSet } from '@/core';
import deepCopy from 'deepcopy';
import getInitialState from './newDeviation.state';
import { deviation as defaultDeviation } from '@/dataStructures';

function cleanState(state) {
	Object.assign(state, getInitialState());
}

function setEditDeviation(state, deviation) {
	Object.assign(state.deviation, defaultDeviation());

	let trip = undefined;
	if (deviation.trip && Object.keys(deviation.trip).length) {
		trip = deviation.trip;
	}
	let orderBindings = undefined;
	if (deviation.orderBindings && deviation.orderBindings.length) {
		orderBindings = deviation.orderBindings;
	}

	state.deviation = {
		...state.deviation,
		...deviation,
		...trip & { trip },
		...orderBindings & { orderBindings },
	};
	state.deviationClone = deepCopy(state.deviation);
	state.dirty = false;
	state.deviationLoaded = true;
}

function setDeviationValue(state, { path, value }) {
	state.dirty = true;
	objectSet(state.deviation, path, value);
}

function setStateValue(state, { path, value }) {
	objectSet(state, path, value);
}

function setTrip(state, trip) {
	state.dirty = true;
	state.deviation.tripId = trip.id;
	state.deviation.trip = trip;
}

export default {
	cleanState,
	setEditDeviation,
	setDeviationValue,
	setStateValue,
	setTrip,
};